import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import styles from './menuHeader.module.scss';
export const MenuHeader = ({ title, isMenuOpen, className }) => {
    return (_jsx("h3", Object.assign({ className: classnames({
            [styles.root]: true,
            [styles.rootCollapsed]: !isMenuOpen,
        }, className) }, { children: title })));
};
